import { Grid, Typography } from '@mui/joy';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { isEmptyObject } from 'core/utils';
import { JobDetails } from 'quotes/components/QuoteDetails';
import { QuoteEntityType } from 'quotes/enums';
import { ICustomerQuote } from 'quotes/types';
import { Level } from 'theme/enums';

import {
  BillToInfo,
  ILoadingFields as IMainInfoLoadingFields,
  MainInfo,
  QuotedByInfo,
  ShipToInfo,
  SoldToInfo,
} from './Sections';
import { GridWrapper, MultiInfoCardWrapper } from './style';

export interface ILoadingFields extends IMainInfoLoadingFields {}

interface IProps {
  quote: ICustomerQuote;
  setQuote: (quote: ICustomerQuote) => void;
  entityType?: QuoteEntityType;
  isEditable?: boolean;
  loadingFields?: ILoadingFields;
}

export const CustomerQuoteBaseInformation = ({
  quote,
  setQuote,
  entityType = QuoteEntityType.QUOTE,
  isEditable = false,
  loadingFields,
}: IProps) => {
  const [isQuotedByEditOpen, setIsQuotedByEditOpen] = useState<boolean>(false);

  const { t } = useTranslation();

  const updateQuote = (updatedQuote?: ICustomerQuote) => {
    if (!isEmptyObject(updatedQuote)) {
      setQuote(updatedQuote);
    }
  };

  return (
    <GridWrapper container>
      <Typography level={Level.H4}>{t('titleBaseInformation')}</Typography>

      <Grid container md={12} spacing={3}>
        <Grid xs={12} md={6} lg={4}>
          <MainInfo
            quote={quote}
            updateQuote={updateQuote}
            entityType={entityType}
            isEditable={isEditable}
            loadingFields={loadingFields}
          />
        </Grid>

        <Grid xs={12} md={6} lg={4}>
          <MultiInfoCardWrapper>
            {!quote?.alternateVersionEnabled && (
              <SoldToInfo
                quote={quote}
                updateQuote={updateQuote}
                entityType={entityType}
                isEditable={isEditable}
              />
            )}
            <QuotedByInfo
              quote={quote}
              updateQuote={updateQuote}
              entityType={entityType}
              isEditable={isEditable}
              isEditOpen={isQuotedByEditOpen}
              setIsEditOpen={setIsQuotedByEditOpen}
            />
          </MultiInfoCardWrapper>
        </Grid>

        <Grid xs={12} md={6} lg={4}>
          <MultiInfoCardWrapper>
            <ShipToInfo
              quote={quote}
              updateQuote={updateQuote}
              entityType={entityType}
              isEditable={isEditable}
            />
            <BillToInfo
              quote={quote}
              updateQuote={updateQuote}
              entityType={entityType}
              isEditable={isEditable}
              onChangeEmployees={isEditable ? () => setIsQuotedByEditOpen(true) : undefined}
            />
          </MultiInfoCardWrapper>
        </Grid>

        <Grid xs={12} md={6} lg={4}>
          <JobDetails quote={quote} updateQuote={updateQuote} />
        </Grid>
      </Grid>
    </GridWrapper>
  );
};
